<template>
    <div class="bottomNav" v-if="navList.length <= 0 || (navList.length > 0)">
        <div class="nav-box" v-if="navList.length > 0">
            <div class="nav-item" :class="{ active: item.curPage }" @click='goPage(item.url, item)'
                v-for="(item, i) in navList" :key="i">

                <img :src="item.logoA" v-if="!item.curPage" :class="{ 'large': item.isLarge == 'T' }" />
                <img :src="item.logoB" v-if="item.curPage" :class="{ 'large': item.isLarge == 'T' }">
                <p :class="{ 'largeTxt': item.isLarge == 'T' }">{{ item.desc }}</p>
            </div>
            <div class="bgWrapper">
                <div class="bgBox" v-for="(item, i) in navList" :key="i">
                    <div class="bg" v-show="item.isLarge == 'T'"></div>
                </div>
            </div>
        </div>
        <div class="nav-box" v-else>
            <div class="nav-item" :class="{ active: icon == 'home' }" @click='goHome'>
                <div class="iconfont iconshouye"></div>
                <p>首页</p>
            </div>
            <div class="nav-item" :class="{ active: icon == 'type' }" @click='goType'>
                <div class="iconfont iconfenlei"></div>
                <p>分类</p>
            </div>
            <div class="nav-item" :class="{ active: icon == 'shopCar' }" @click='goShopCar' v-if="isCloseShopCart != 'T'">
                <div class="iconfont icongouwuche"></div>
                <p>购物车</p>
                <div class="num" v-if="shopCartNum > 0">
                    <b v-if="shopCartNum > 99" class="more">
                        <image src="https://xcx.ihotel.cn/mall-chain/orderStatusMore.png">
                        </image>
                    </b>
                    <b v-else>{{ shopCartNum }}</b>
                </div>
            </div>
            <div class="nav-item" :class="{ active: icon == 'my' }" @click='goMemberCenter'>
                <div class="iconfont iconwode"></div>
                <p>我的</p>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/utils/api';
import {
    jAlert3
} from '@/base/jAlert/jAlert';
import {
    getStorage
} from '@/utils/wxuser';
import gcTrack from "@/utils/gcTrack";
var config = {};

export default {
    data() {
        return {
            navList: {},
            curPage: false,
            isCloseShopCart: getStorage("isCloseShopCart"),
            wxuser: getStorage('wxuser'),
            user: getStorage('user')
        };
    },
    props: {
        icon: {
            type: String,
        },
    },
    computed: {
        shopCartNum() {
            return this.$store.getters.getShopcartNum;
        },
    },
    mounted() {
        this.getNav();
        this.getShopCartNum()
    },
    methods: {
        goPage(url, item) {
            gcTrack.track("SC_BottomButtonClick", {
                bottom_name: item.moduleName
            })
            this.goLink(url)
            // window.location.href = url;
        },
        goType() {
            gcTrack.track("SC_BottomButtonClick", {
                bottom_name: '分类'
            })
            this.$router.push({
                path: '/typeList',
            });
        },
        goHome() {
            gcTrack.track("SC_BottomButtonClick", {
                bottom_name: '首页'
            })
            this.$router.push({
                path: '/index',
            });
        },
        getShopCartNum() {
            if(this.$store.getters.getShopcartNum>-1){
                return
            }
            let opt = {
                hotelGroupCode: config.hotelGroupCode,
                equipment: config.equipment,
                appid: config.appid
            }
            if (this.wxuser && this.wxuser.openid) {
                opt.openid = this.wxuser.openid
            } else {
                return false
            }
            if (this.user && this.user.memberId) {
                opt.memberId = this.user.memberId
            }

            api.listShopCart(opt).then(res => {
                if (res.result == 1) {
                    this.$store.commit("SHOPCART_NUM", res.retVal.length);

                } else {
                    jAlert3(res.msg)
                }
            })
        },
        goShopCar() {
            gcTrack.track("SC_BottomButtonClick", {
                bottom_name: '购物车'
            })
            this.$router.push({
                path: '/shopCart',
            });
        },
        goMemberCenter() {
            gcTrack.track("SC_BottomButtonClick", {
                bottom_name: '我的'
            })
            this.$router.push({
                path: '/memberCenter',
            });
            // window.location.href="/wechat/?/#/memberCenter"
        },

        getNav() {
            //   var pages = getCurrentPages();
            var curPage = this.$router.currentRoute.path;
            api.getShopButtonConfig({
                hotelGroupCode: config.hotelGroupCode,
                appid: config.appid,
                businessType: "2"
            }).then((res) => {
                if (res.result == 1) {
                    if (res.retVal.length > 0) {
                        this.navList = JSON.parse(res.retVal[0].info)
                        this.navList.forEach(item => {
                            item.url = item.url.replace('/=#/', '/#/')
                            var url = item.url.split('/#')[1];
                            if (url) {
                                url = url.split('?')[0];
                            }
                            if ((curPage == url)) {
                                if (curPage.indexOf("/polymerization") != -1) {
                                    if (item.url.indexOf(this.$route.query.id) != -1) {
                                        item.curPage = true;
                                        this.curPage = true;
                                    }
                                } else {
                                    item.curPage = true;
                                    this.curPage = true;
                                }

                            }
                        })

                    } else {
                        api.getListType({
                            hotelGroupCode: config.hotelGroupCode,
                            belongHotelCode: config.hotelCode,
                            isBottom: 'T'
                        })
                            .then((res) => {
                                if (res.result === 1) {
                                    this.navList = [];
                                    res.retVal.forEach((item) => {
                                        var clientType = config.clientType
                                        if (config.clientType == 'wechat_mini') {
                                            clientType = 'wechat_mini_pro'
                                        }
                                        if (item.clientType == clientType) {
                                            item.logoA = item.logo.split(',')[0];
                                            item.logoB = item.logo.split(',')[1];
                                            item.desc = item.moduleName
                                            if (item.url.split('/#')[1]) {
                                                var url = item.url.split('/#')[1];
                                                if ((curPage == url.split('?')[0])) {
                                                    item.curPage = true;
                                                    this.curPage = true;
                                                }
                                            }
                                            this.navList.push(item);
                                        }
                                    });


                                } else {
                                    jAlert3(res.msg);
                                }
                            });
                    }
                } else {
                    jAlert3(res.msg);
                }
            })

        },
    },
    created() {
        config = getStorage('config');

    },
};
</script>

<style lang="less" scoped>
@import url('~@/styles/base.less');
@import url('~@/styles/mixin.less');

.bottomNav {
    position: fixed;
    z-index: 99;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    display: flex;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.9);
    padding-bottom: constant(safe-area-inset-bottom);
    padding-bottom: env(safe-area-inset-bottom);

    .nav-box {
        width: 100%;
        background: #fff;
        display: flex;
        box-sizing: border-box;
        height: 50px;
    }

    .nav-item {
        position: relative;
        display: flex;
        flex-direction: column;
        justify-content: center;
        text-align: center;
        align-items: center;
        flex: 1;
        font-size: 10px;
        color: #999;
        .num {
			position: absolute;
			left: 50%;
			top: 0.08rem;
			margin-left: 0.13rem;

			b {
				display: flex;
				align-items: center;
				justify-content: center;

				font-size: 10px;
				color: #fff;
				background: #E76434;
				padding: 0 0.11rem;
				min-height: 0.40rem;
				min-width: 0.40rem;
				box-sizing: border-box;
				border-radius: 0.20rem;
				border: 1px solid #E76434;
			}

			.more {
				background: none;
				border: 0;
				margin-left: -0.13rem;
			}

			image {
				width: 0.60rem;
				height: 0.40rem;
			}

		}
        .iconfont {
            color: #999;
            font-size: 24px;
        }

        p {
            margin-top: 5px;
        }

        img {
            height: 24px;
            width: 24px;

            &.large {
                width: 44px;
                height: 44px;
                position: relative;
                top: -15px;
            }
        }

        .largeTxt {
            position: relative;
            top: -10px;
        }

        .icon-active {
            display: none;
        }

        &.active {
            color: @color-theme;

            .iconfont {
                color: @color-theme;
            }

            .icon-noActive {
                display: none;
            }

            .icon-active {
                display: block;
            }
        }
    }

    .bgWrapper {
        height: 100%;
        display: flex;
        left: 0;
        bottom: 0;
        height: 100%;
        z-index: -1;
        position: absolute;
        width: 100%;

        .bgBox {
            flex: 1;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 11px;
            color: #999999;
            flex-direction: column;
            position: relative;

            .bg {
                background: #fff;
                position: absolute;
                left: 50%;
                -webkit-transform: translateX(-50%);
                transform: translateX(-50%);
                z-index: -1;
                height: 66px;
                width: 66px;
                border-radius: 50%;
                box-shadow: 0 2px 8px rgba(0, 0, 0, 0.4);
                top: -25px;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/bottomNav.vue